module.exports = __webpack_public_path__ + "static/img/video-call-image.6adce1b.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/video-call-image.png
// module id = Emmv
// module chunks = 1